import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <Container className="footer" id="footer">
      <FooterContainer className="container">
        <FooterSns className="footer-sns">
          <SnsLink
            href="https://www.youtube.com/channel/UC1Gk6BXVUHCYpPNUJJtpHyA"
            target="_blank"
            className="sns-link youtube"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </SnsLink>
          <SnsLink
            href="https://www.band.us/band/63797765/post"
            target="_blank"
            className="sns-link band"
          >
            BAND
          </SnsLink>
        </FooterSns>
        <FooterLogo href="#" className="footer-logo">
          처음사랑교회
        </FooterLogo>

        <FooterInfo className="footer-info">
          <p>담임목사: 편해윤 | 경기도 부천시 부일로 278, 강남빌딩 3-4층</p>
          <p>Tel: 010.9978.8790 | Email: hereami21@gmail.com</p>
          <p className="copyright">
            &copy; 2026 FIRST LOVE CHURCH. All Rights Reserved.
          </p>
        </FooterInfo>
      </FooterContainer>
    </Container>
  );
};

const Container = styled.footer`
  background: #222;
  color: #888;
  padding: 15px 0 40px 0;
  font-size: 14px;
  border-top: 5px solid #004094;

  @media (max-width: 768px) {
    padding: 15px 0 30px 0;
  }

  @media (max-width: 480px) {
    padding: 15px 0 25px 0;
  }
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: left;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

const FooterSns = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
`;

const SnsLink = styled.a`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #333;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border: 1px solid #444;
  transition: 0.3s;
  font-family: "Paperlogy", sans-serif;
  font-weight: 700;

  i {
    font-size: 24px;
  }

  &.youtube:hover {
    background: #ff0000;
    border-color: #ff0000;
  }

  &.instagram:hover {
    background: #e1306c;
    border-color: #e1306c;
  }

  &.facebook:hover {
    background: #1877f2;
    border-color: #1877f2;
  }

  &.band:hover {
    background: #03cf5d;
    border-color: #03cf5d;
  }

  &.blog:hover {
    background: #2db400;
    border-color: #2db400;
  }
`;

const FooterLogo = styled.a`
  font-family: "ComputerLaundry", monospace;
  font-size: 20px;
  font-weight: 400;
  color: white;
  margin-bottom: 20px;
  display: block;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const FooterInfo = styled.div`
  text-align: left;

  p {
    margin-bottom: 8px;
    font-weight: 300;
    text-align: left;
    word-break: keep-all;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    p {
      font-size: 13px;
    }
  }

  @media (max-width: 480px) {
    p {
      font-size: 12px;
      line-height: 1.5;
    }
  }
`;

export default Footer;
